var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 64C114.6 26.7 150.2 0 192 0s77.4 26.7 90.5 64L384 64l0 448L0 512 0 64l101.5 0zM224 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM198.6 208L176 185.4l-11.3 11.3L112 249.4 91.3 228.7 80 217.4 57.4 240l11.3 11.3 32 32L112 294.6l11.3-11.3 64-64L198.6 208zm9.4 48l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0zm-48 96l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zM96 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSurvey);
export default __webpack_public_path__ + "static/media/nav_survey.8a133b32e297b3e7f0987e950c5853e9.svg";
export { ForwardRef as ReactComponent };